export default "__VITE_ASSET__D9UMsT99__"